const { sum, range } = require('d3-array')
const mult = (a = [], b = []) => a.map((a, i) => a * (b[i] || 0))
const cumsum = (a = []) =>
  a.reduce((acc, cur) => [...acc, cur + (acc[acc.length - 1] || 0)], [])

/**
	Calculates the number of viruses inhaled by each person in the room after `timeInRoom` minutes.
**/
function calcCovidDose({
  roomVolume = 50,
  airExchangeRate = 1,
  timeInRoom = 60,
  maskEfficiencyExhaled = 0,
  maskEfficiencyInhaled = 0,
  emitterType = 'very',
  activityLevel = 'low',
  voiceStrengths = [1, 0, 0],
  criticalDose = 500
}) {
  //* constants
  const virusHalfLife = 66 // min
  const activityEmissions = [7500, 15000, 45000] // m^3/min
  const voiceEmissionsByEmitterType = {
    // PM10_frac/cm^3
    normal: [1.14e-6, 1.11e-5, 1.11e-4],
    high: [0.0019581, 0.019122, 0.1912196],
    very: [0.0795979, 0.7773229, 7.773229],
    super: [0.6312327, 6.164382, 61.64382]
  }
  const activityLevels = {
    low: [1, 0, 0],
    medium: [0, 1, 0],
    high: [0, 0, 1]
  }

  //* intermediate values
  const RV = sum(mult(activityLevels[activityLevel], activityEmissions))
  const ES = sum(mult(voiceStrengths, voiceEmissionsByEmitterType[emitterType]))
  const S_tot = (1 - maskEfficiencyExhaled) * RV * ES
  // console.debug('S_tot', S_tot)
  const lossRate = Math.log(2) / virusHalfLife + airExchangeRate / 60 // k_tot
  // console.debug('k_tot', lossRate)
  const cFactor = S_tot / (roomVolume * lossRate)
  function c(t) {
      return cFactor * (1 - Math.exp(-lossRate * t))
  }

  //* create lookup tables
  const maxTime = 720
  let t = 0
  let maxDose = 0
  const counts = []
  const doses = []
  while (t <= timeInRoom || maxDose <= criticalDose) {
    const nextCount = c(t) + (counts[counts.length - 1] || 0)
    const nextDose = (1 - maskEfficiencyInhaled) * (RV * 1e-6) * nextCount
    counts.push(nextCount)
    doses.push(nextDose)
    maxDose = nextDose
    t += 1
    if (t >= maxTime) {
      break;
    }
  }
  const timeUntilCritical = doses.findIndex(d => Math.ceil(d) >= criticalDose)

  // const minutes = range(0, 720)
  // const counts = cumsum(minutes.map(c))
  // const doses = counts.map(
  //   count => (1 - maskEfficiencyInhaled) * (RV * 1e-6) * count
  // )
  // const timeUntilCritical = doses.findIndex(d => Math.ceil(d) >= criticalDose)

  //* result
  const dose = doses[timeInRoom]
  // console.debug('dose_FF', dose_FF)
  // console.log('timeUntilCritical', timeUntilCritical)
  // console.log(doses.slice(0, timeUntilCritical))

  return [dose, timeUntilCritical > 0 ? timeUntilCritical : maxTime]
}

module.exports = calcCovidDose
